
import { Component, Vue } from 'vue-property-decorator'
import '@/theme/scss/components/item.scss'

@Component({})
export default class Sectors extends Vue {
  showComponent: boolean = false
}
